export const Homework = {
    "生成个人作业":"生成个人作业",
    "生成小组作业":"生成小组作业",
    "小组作业":"小组作业",
    "个人作业":"个人作业",
    "评审型作业":"评审型作业",
    "查重警戒值":"查重警戒值",
    "共":"共",
    "人":"人",
    "暂无学号":"暂无学号",
    "提交时间":"提交时间：",
    "超":"超",
    "查重":"查重",
    "未交":"未交",
    "已催交":"| 已催交",
    "次":"次",
    "打回时间":"| 打回时间",
    "成员":"",
    "提交状态":"提交状态",
    "正常":"正常",
    "超时交":"超时交",
    "字数":"字数",
    "第一次作业":"第一次作业",
    "创建于2020/01/09 12:09":"创建于2020/01/09 12:09",
    "已阅":"已阅",
    "查重设置":"查重设置",
    "是否查重":"是否查重",
    "未填写":"未填写",
    "查重率高过上限自动打回":"查重率高过上限自动打回",
    "查重率上限":"查重率上限",
    "截至时间设置":"截至时间设置",
    "是否限制截止时间":"是否限制截止时间",
    "日期":"日期",
    "若超时禁止提交":"若超时,禁止提交",
    "具体时间":"具体时间",
    "选择日期":"选择日期",
    "满分值":"满分值",
    "总分设置":"总分设置",
    "新建个人作业":"新建个人作业",
    "新建小组作业":"新建小组作业",
    "作业标题":"作业标题",
    "作业详情":"作业详情",
    "未开启查重":"未开启查重",
    "开启查重":"开启查重",
    "小组批次":"小组批次",
    "个人":"个人",
    "小组":"小组",
    "请选择截止时间":"请选择截止时间",
    "分值设置":"分值设置",
    "评语要求":"评语要求：",
    "至少":"至少",
    "字":"字",
    "批阅设置":"批阅设置",
    "批阅人":"批阅人",
    "作业批阅分配方式":"作业批阅分配方式",
    "每份作业一个人批阅":"每份作业一个人批阅",
    "每份作业随机":"每份作业随机",
    "人批阅":"人批阅",
    "匿名评审":"匿名评审",
    "评审批阅时学生信息匿名展示":"评审批阅时学生信息匿名展示",
    "评分方式":"评分方式",
    "取平均值":"取平均值",
    "去掉最高分和最低分取平均值":"去掉最高分和最低分，取平均值",
    "筛选":"筛选",
    "批阅状态":"批阅状态：",
    "条数据":"条数据",
    "暂时无数据":"暂时无数据～",
    "全选本页":"全选本页",
    "催交":"催交",
    "请确认是否要催交作业":"请确认是否要催交作业？",
    "不催了":"不催了",
    "立即催交":"立即催交",
    "共选择了":"共选择了",
    "等共":"，等共",
    "学生催交的学生将会收到催交信息":"学生，催交的学生将会收到催交信息",
    "位":"位",
    "组":"组",
    "已批组":"已批组",
    "未批组":"未批组",
    "未交组":"未交组",
    "催交成功":"催交成功",
    "提交作业":"提交作业",
    "更新提交":"更新提交",
    "更新提交被打回":"更新提交（被打回）",
    "查看批阅":"查看批阅",
    "请先加入小组":"请先加入小组",
    "完成本次小组作业需要先参与进行本次作业所要求的分组任务并加入某一小组":"完成本次小组作业，需要先参与进行本次作业所要求的分组任务，并加入某一小组。",
    "重置":"重置",
    "按时交":"按时交",
    "整体查重率":"整体查重率",
    "文件列表":"文件列表",
    "点击文件可查看重复段落每次作业":"点击文件可查看重复段落，每次作业",
    "点击文件可查看重复段落每个文档":"点击文件可查看重复段落，每个文档",
    "仅有一次机会":"仅有一次机会",
    "有5次机会":"有5次机会",
    "有10次机会":"有10次机会",
    "查重率":"查重率",
    "确定使用查看重复段落的机会吗":"确定使用查看重复段落的机会吗?",
    "本次作业只有1次查看1个文件的机会":"本次作业只有1次查看1个文件的机会",
    "本次作业只有 1 次查看机会并且只能查看所有提交的文件中的 1 个附件文件的重复段落请慎重决定":"本次作业，只有 1 次查看机会，并且只能查看所有提交的文件中的 1 个附件文件的重复段落。请慎重决定！",
    "作业查重信息":"作业查重信息",
    "查重规则":"查重规则",
    "仍要查看":"仍要查看",
    "已无查看重复段落的机会":"已无查看重复段落的机会!",
    "查看重复片段机会已用完":"查看重复片段机会已用完!",
    "文件格式不支持查重":"文件格式不支持查重",
    "暂无重复段落":"暂无重复段落",
    "表示查重还没有完毕其他同学还未提交作业文件格式不支持查看视频和图片":"表示查重还没有完毕；其他同学还未提交作业；文件格式不支持查看（视频和图片）",
    "查重率是动态变化的任何同学新提交的作业都会导致查重率的改变有多个文档时以最大查重率文档为基准字数也是一样的规则":"查重率是动态变化的，任何同学新提交的作业都会导致查重率的改变。有多个文档时，以最大查重率文档为基准，字数也是一样的规则。",
    "给分":"给分",
    "打回":"打回",
    "请确认是否要打回作业":'请确认是否要打回作业？',
    "学生的作业":"学生的作业",
    "选填打回理由":"(选填）打回理由",
    "批量给分":"批量给分",
    "请输入分数":"请输入分数",
    "请至少勾选一个作业":"请至少勾选一个作业",
    "对学生隐藏成绩":"对学生隐藏成绩",
    "审评截止":"审评截止：",
    "批量操作":"批量操作",
    "再次催交":"再次催交",
    "移动端暂不支持批阅请前往电脑端查看批阅详情":"移动端暂不支持批阅，请前往电脑端查看批阅详情",
    "已显示":"已显示",
    "已隐藏":"已隐藏",
    "批阅作业":"批阅作业",
    "批阅":"批阅",
    "未批阅":"未批阅",
    "批阅小组作业":"批阅小组作业",
    "统一给分":"统一给分",
    "老师评语":"老师评语",
    "请输入对学生的评语":"请输入对学生的评语",
    "学生作业":"学生作业",
    "提交历史":"提交历史",
    "手机仅支持浏览请在电脑端添加批注":"手机仅支持浏览，请在电脑端添加批注",
    "查看批注":"查看批注",
    "学生留言":"学生留言",
    "暂无留言":"暂无留言",
    "上一位":"上一位",
    "上一组":"上一组",
    "下一位":"下一位",
    "下一组":"下一组",
    "打回学生作业":"打回学生作业",
    "分享学生作业":"分享学生作业",
    "分享小组作业":"分享小组作业",
    "已批阅的同学才能看到防止抄袭":"已批阅的同学才能看到，防止抄袭",
    "匿名分享名称显示为***学生":"匿名分享，名称显示为（***学生）",
    "匿名分享名称显示为***小组":"匿名分享，名称显示为（***小组）",
    "选填分享理由":"（选填）分享理由...",
    "给学生打分":"给学生打分",
    "请打分":"请打分",
    "作业批阅":"作业批阅",
    "取消分享":"取消分享",
    "发表成功":"发表成功",
    "成绩已变更":"成绩已变更",
    "已分享":"已分享",
    "确认取消分享该作业":"确认取消分享该作业？",
    "已取消分享":"已取消分享",
    "这是第一个学生作业":"这是第一个学生作业",
    "已经是最后一个学生作业":"已经是最后一个学生作业",
    "组长":"组长",
    "暂无小组成员":"暂无小组成员~",
    "已交名单":"已交名单",
    "作业提交成功请耐心等待老师批阅":"作业提交成功，请耐心等待老师批阅",
    "作业被老师打回请重新上传":"作业被老师打回，请重新上传",
    "打回理由":"打回理由",
    "已批阅成绩未发布":"已批阅，成绩未发布",
    "已批阅成绩":"已批阅，成绩",
    "查看重复率":"查看重复率",
    "系统默认查看":"*系统默认查看",
    "已分享作业":"已分享作业",
    "提交详情":"提交详情",
    "看谁交了":"看谁交了",
    "课后作业":"课后作业",
    "作业附件":"作业附件",
    "作业留言":"作业留言",
    "支付单次查重费用":"支付单次查重费用",
    "确定支付":"确定支付",
    "开通会员每月低至2元即可无限查重":"开通会员，每月低至2元，即可无限查重 >>",
    "升级会员尊享更多vip权益":"升级会员，尊享更多vip权益 >",
    "元次":"元/次",
    "立即提交":"立即提交",
    "立即提交已超时":"立即提交（已超时）",
    "重新提交":"重新提交",
    "重新提交已超时":"重新提交（已超时）",
    "更新提交已超时":"更新提交（已超时）",
    "查看作业":"查看作业",
    "温馨提醒":"温馨提醒",
    "确定要更新作业吗":"确定要更新作业吗",
    "当前时间已超过作业提交截止时间重新提交的作业将被标为超时交":"当前时间已超过作业提交截止时间，重新提交的作业将被标为超时交。",
    "去更新":"去更新",
    "更新作业":"更新作业?",
    "更新作业并提交之后作业的提交时间将以现在的时间为准":"更新作业并提交之后，作业的提交时间将以现在的时间为准！",
    "此功能仅对VIP用户开放开通VIP后可实时查看同班同学提交作业的情况另外还可享受更多VIP权益":"此功能仅对VIP用户开放，开通VIP后可实时查看同班同学提交作业的情况，另外还可享受更多VIP权益",
    "支付成功":"支付成功",
    "小组成员":"小组成员",
    "提交次数":"提交次数",
    "暂无作业提交":"暂无作业提交~",
    "分享理由":"分享理由",
    "暂无分享作业":"暂无分享作业~",
    "系统默认查重":"*系统默认查重",
    "添加作业":"添加作业",
    "作业必须以附件的方式提交":"*作业必须以附件的方式提交",
    "添加留言作业要以附件的形式提交而不是写在留言里":"添加留言，作业要以附件的形式提交，而不是写在留言里",
    "提交完成":"提交完成",
    "正在保存答案请稍后提交":"正在保存答案,请稍后提交",
    "题未作答是否提交":"题 未作答，是否提交？",
    "继续提交":"继续提交",
    "再等等":"再等等",
    "您已选择":"您已选择",
    "项少选了":"项，少选了",
    "AI批阅评语":"AI批阅评语",
    "参考答案设置":"参考答案设置",
    "答案内容":"答案内容",
    "参考答案附件":"参考答案附件",
    "答案公布时间":"答案公布时间",
    "不设置":"不设置",
    "作业参考答案":"作业参考答案",
    "答案将于指定时间公布":"答案将于 {time} 公布",
    "高级问题作业":"高级问题作业",
    "总题目":"总题目",
    "进度":"进度",
    "步骤":"步骤",
    "得分":"得分",
    "最终得分":"最终得分",
    "AI追问":"AI追问",
    "本步尚未通过":"本步尚未通过",
    "本步得分":"本步得分",
    "本步评语":"本步评语",
    "追问进度":"已追问 {current}/{max} 次",
    "追问后请修改回答再提交":"请根据 AI 追问修改下方回答，然后再次点击「再次提交本步」。达到最大追问次数后将自动进入下一步。",
    "请根据评语修改回答再提交":"请根据上方评语修改下方回答，然后再次点击「再次提交本步」。",
    "再次提交本步":"再次提交本步",
    "修改回答后再次提交":"修改回答后，点击下方「再次提交本步」",
    "本步尚未通过请修改后再提交":"本步尚未通过，请查看 AI 反馈并修改回答后再提交",
    "AI学习助手":"AI学习助手",
    "我的回答":"我的回答",
    "请输入你的回答":"请输入你的回答",
    "暂存":"暂存",
    "提交本步":"提交本步",
    "已完成全部步骤":"已完成全部步骤",
    "已暂存":"已暂存",
    "暂存失败":"暂存失败",
    "提交失败请重试":"提交失败，请重试",
    "AI助手暂不可用":"AI助手暂不可用，请直接作答",
    "正在加载AI助手":"正在加载AI助手...",
    "AI助手VIP未开通学生提示":"AI 学习助手暂不可用，请提醒任课老师开通 AI 智能体使用权限",
    "AI助手VIP过期学生提示":"AI 学习助手暂不可用，请提醒任课老师续费开通",
    "智能体平台未开通提示":"高级问题作业依赖智能体平台，请先前往开通后再使用",
    "智能体平台已失效提示":"智能体平台已失效，请前往续费后再使用",
    "AI助手使用说明":"与 AI 讨论思路；在「作答」中填写正式回答并点击「提交本步」",
    "AI助手欢迎语":"同学你好！我们正在攻克「{stepTitle}」这一步。先别急着要答案——说说你现在的想法或卡住的地方，哪怕只是一点点直觉也行，我会一步步陪你把它想清楚。",
    "AI助手快捷提问_1":"我还不太理解这一步要做什么",
    "AI助手快捷提问_2":"我有初步想法，但不确定对不对",
    "AI助手快捷提问_3":"请给我一个不直接给答案的提示",
    "回答公式说明":"支持 Markdown 与 LaTeX；可点「预览」查看排版与公式",
    "作答":"作答",
    "AI助手":"AI助手",
    "预览":"预览",
    "返回编辑":"返回编辑",
    "点击返回编辑":"点击此处返回编辑",
    "收起预览":"收起预览",
    "继续作答":"继续作答",
    "查看作答":"查看作答",
    "进入作答":"进入作答",
    "教师评语":"教师评语",
    "移动端暂不支持高级问题批阅请前往电脑端":"移动端暂不支持高级问题作业批阅，请前往电脑端操作",
    "高级问题作业请在电脑端配置":"高级问题作业的分步配置与批阅请使用电脑端",
    "当前步骤":"当前步骤",
    "已完成步骤":"已完成步骤",
    "展开题目":"展开题目",
    "收起题目":"收起题目",
    "本步要求":"本步要求",
    "插入公式":"插入公式",
    "公式输入占位":"输入 LaTeX，如 \\frac{a}{b} 或 x^{2}",
    "块级公式":"块级公式（居中显示）",
    "插入":"插入",
    "取消":"取消",
}
